/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multiview_Track_Select_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Select track for event" |
*
* @param {Multiview_Track_Select_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multiview_track_select_aria_label = /** @type {((inputs?: Multiview_Track_Select_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multiview_Track_Select_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez la piste pour l'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Track für Veranstaltung auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il tracciato per l'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите трек для мероприятия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione la pista para el evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择赛事赛道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントのトラックを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट के लिए ट्रैक चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a faixa para o evento")
	return /** @type {LocalizedString} */ ("Select track for event")
});